module.exports = __webpack_public_path__ + "media/images/bank_images/bmc-5a8027381aa1cb8a2af177e079511a44.png";